import { DialogsMessageHandler } from './DialogsMessageHandler';
import { HostMessageType } from './interfaces/IMessageHandler';

/**
 * AppHostEventListener - register for MessageEvent and process only required messages.
 */
export class AppHostEventListener {
  constructor(protected hostEvent: Window) {}

  public registerEventHandler(dialogMessageHanlder: DialogsMessageHandler): void {
    const messageReceiver = (event: MessageEvent<any>): void => {
      switch (event.data?.func) {
        case HostMessageType.DialogSubmit:
          dialogMessageHanlder.handleMessage(event.data.func, event.data.args || '', event.data.timestamp);
          break;
      }
    };

    if (this.hostEvent) {
      this.hostEvent.addEventListener('message', messageReceiver);
    }
  }
}
